"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitMailchimpForm = void 0;
const MAILCHIMP_INTERNAL_URL = "/api/public-site/mailchimp";
const postMailchimpForm = async (form) => {
    try {
        const response = await fetch(MAILCHIMP_INTERNAL_URL, {
            method: "POST",
            body: JSON.stringify(form),
        });
        if (response?.status === 201) {
            return response?.statusText || "Form submitted";
        }
        return await Promise.reject(response);
    }
    catch (err) {
        return Promise.reject(err);
    }
};
const submitMailchimpForm = (email) => {
    postMailchimpForm({
        email,
        pathname: window.location.pathname,
    }).catch(console.error);
};
exports.submitMailchimpForm = submitMailchimpForm;
//# sourceMappingURL=mailchimp.js.map